import { useAuthContext } from "components/context/authContext";
import { useNavigate } from "react-router-dom";
import "./error.scss";

export default function ErrorPage() {
  const navigate = useNavigate();
  const { lodInf } = useAuthContext();

  return (
    <>
      <section className="error-out">
        <div className="error-cont">
          <i className="fa fa-exclamation fa-5x" aria-hidden="true"></i>
          <h1>요청하신 페이지를 찾을 수 없습니다.</h1>
          <p>
            방문하시려는 페이지의 주소가 잘못 입력되었거나,
            <br /> 페이지의 주소가 변경 혹은 삭제되어 요청하신 페이지를 찾을 수
            없습니다.
            <br /> 입력하신 주소가 정확한지 다시 한번 확인해 주시기 바랍니다.
          </p>
          <div className="err-btn">
            <button onClick={() => navigate(-1)}>이전페이로</button>
            <button
              onClick={() => navigate(`/${lodInf?.lodNo}`, { replace: true })}
            >
              메인으로
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
